export default "__VITE_ASSET__Gsy1Pjnd__"